import { render, staticRenderFns } from "./AvaliacaoLiderComponent.vue?vue&type=template&id=34122f30&scoped=true"
import script from "./AvaliacaoLiderComponent.vue?vue&type=script&lang=js"
export * from "./AvaliacaoLiderComponent.vue?vue&type=script&lang=js"
import style0 from "./AvaliacaoLiderComponent.vue?vue&type=style&index=0&id=34122f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34122f30",
  null
  
)

export default component.exports